export const environment = {
  production: false,
  app: {
    name: 'Kaizen Dev',
  },
  api: {
    url: 'https://api.dev.kaizencoworks.com/api',
  },
};
